import { FC } from 'react';

import { dibsLazyClient } from 'dibs-lazy/exports/dibsLazyClient';
import { ClientSuspense } from 'dibs-elements/exports/ClientSuspense';

const PdpRespSharedQrCode = dibsLazyClient(
    () => import(/* webpackChunkName: "PdpRespSharedQrCode" */ './PdpRespSharedQrCode')
);

export const PdpRespSharedQrCodeLazy: FC<{
    itemId: string | null;
    className: string;
}> = ({ itemId, className }) => (
    <ClientSuspense fallback={null}>
        <div className={className}>
            <PdpRespSharedQrCode itemId={itemId} />
        </div>
    </ClientSuspense>
);
